var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSecurity(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 158,
    height: 158,
    viewBox: "0 0 158 158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path21",
    d: "M0-682.665H158v158H0Z",
    transform: "translate(0 682.665)",
    fill: "#2979ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g15",
    transform: "translate(0 682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "translate(0 -682.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g19",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g25",
    transform: "translate(26.639 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path27",
    d: "M-277.7-480.147a2.314,2.314,0,0,1-2.068-1.273,2.314,2.314,0,0,1,1.024-3.109c35.992-18.151,48.816-54.561,42.653-121.489a92.514,92.514,0,0,1-24.121,3.247c-14.994,0-33.623-3.9-48.759-19.3-15.583,15.859-34.737,19.4-48.724,19.4-.459,0-.912,0-1.36-.011a2.314,2.314,0,0,1-2.276-2.352,2.315,2.315,0,0,1,2.352-2.276c13.638.223,33.087-3.012,48.3-19.687a2.315,2.315,0,0,1,1.71-.755,2.314,2.314,0,0,1,1.71.755c28.457,31.2,71.98,15.922,72.416,15.764a2.314,2.314,0,0,1,2.022.218,2.315,2.315,0,0,1,1.069,1.73c7,70.937-6.427,109.484-44.906,128.89A2.306,2.306,0,0,1-277.7-480.147Z",
    transform: "translate(361.334 627.753)",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g29",
    transform: "translate(0.044 16.381)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path31",
    d: "M2.867,118.07a2.315,2.315,0,0,1-.465-.047C-60.617,105.086-82.854,64.674-74.35-21.462a2.315,2.315,0,0,1,1.068-1.729,2.316,2.316,0,0,1,2.021-.22,75,75,0,0,0,13.117,3.023,2.314,2.314,0,0,1,1.955,2.625,2.314,2.314,0,0,1-2.625,1.955,87.836,87.836,0,0,1-11.2-2.367C-77.576,63.906-56.993,100.934,2.867,113.392a137.66,137.66,0,0,0,20.614-5.886,2.314,2.314,0,0,1,1.641,4.328,142.875,142.875,0,0,1-21.789,6.188A2.315,2.315,0,0,1,2.867,118.07Z",
    transform: "translate(76.089 23.549)",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g33",
    transform: "translate(15.421 20.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path35",
    d: "M-473.725-74a2.312,2.312,0,0,1-.511-.057c-13.022-2.95-23.515-7.117-32.077-12.738a58.94,58.94,0,0,1-20.276-22.253c-5.04-9.537-8.221-21.112-9.724-35.386a219.921,219.921,0,0,1-.6-34.439,2.315,2.315,0,0,1,.82-1.65,2.315,2.315,0,0,1,1.766-.528,100.275,100.275,0,0,0,11.967.718c18.068-.009,33.97-4.973,47.266-14.753a2.315,2.315,0,0,1,2.743,0c13.3,9.78,29.2,14.743,47.265,14.753a102.425,102.425,0,0,0,11.968-.718,2.314,2.314,0,0,1,1.766.528,2.315,2.315,0,0,1,.82,1.65c.3,5.884.43,11.541.372,16.814a2.315,2.315,0,0,1-2.34,2.289,2.314,2.314,0,0,1-2.289-2.34c.049-4.444-.035-9.169-.249-14.079-3.324.318-6.693.481-10.046.485-18.464-.01-34.817-4.943-48.638-14.666-13.821,9.723-30.174,14.657-48.633,14.666-3.3,0-6.672-.159-10.051-.484a210.317,210.317,0,0,0,.7,31.27c1.44,13.676,4.454,24.7,9.213,33.708a54.424,54.424,0,0,0,18.724,20.547c7.979,5.239,17.813,9.159,30.047,11.976,12.234-2.817,22.068-6.737,30.048-11.976a54.43,54.43,0,0,0,18.724-20.547c4.759-9.006,7.773-20.032,9.213-33.708q.284-2.7.485-5.524a2.315,2.315,0,0,1,2.472-2.145,2.314,2.314,0,0,1,2.145,2.472q-.206,2.9-.5,5.681c-1.5,14.274-4.684,25.849-9.724,35.387A58.946,58.946,0,0,1-441.137-86.8c-8.562,5.621-19.055,9.788-32.077,12.738A2.311,2.311,0,0,1-473.725-74Z",
    transform: "translate(537.303 195.539)",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g37",
    transform: "translate(64.342 45.169)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path39",
    d: "M-89.664-83.452h-24.687a2.314,2.314,0,0,1-2.314-2.314v-11.17a14.675,14.675,0,0,1,14.658-14.658A14.675,14.675,0,0,1-87.35-96.936v11.17A2.314,2.314,0,0,1-89.664-83.452Zm-22.373-4.629h20.059v-8.855a10.041,10.041,0,0,0-10.029-10.029,10.041,10.041,0,0,0-10.029,10.029Z",
    transform: "translate(116.666 111.594)",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g41",
    transform: "translate(72.057 81.674)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path43",
    d: "M-43.057-30a6.951,6.951,0,0,1,6.943,6.943,6.951,6.951,0,0,1-6.943,6.943A6.951,6.951,0,0,1-50-23.057,6.951,6.951,0,0,1-43.057-30Zm0,9.258a2.317,2.317,0,0,0,2.314-2.314,2.317,2.317,0,0,0-2.314-2.314,2.317,2.317,0,0,0-2.314,2.314A2.317,2.317,0,0,0-43.057-20.742Z",
    transform: "translate(50 30)",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g45",
    transform: "translate(76.686 90.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path47",
    d: "M-7.686-.213A2.314,2.314,0,0,1-10-2.527V-7.686A2.314,2.314,0,0,1-7.686-10,2.314,2.314,0,0,1-5.371-7.686v5.158A2.314,2.314,0,0,1-7.686-.213Z",
    transform: "translate(10 10)",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g49",
    transform: "translate(28.391 48.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path51",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g53",
    transform: "translate(129.609 48.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path55",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g57",
    transform: "translate(79 128.648)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path59",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g61",
    transform: "translate(79 36.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path63",
    fill: "#2979ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g65",
    transform: "translate(52.488 68.683)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path67",
    d: "M15.521-63.062C4.8-63.062-2.812-66.448-7.1-73.127a2.314,2.314,0,0,1,.7-3.2,2.314,2.314,0,0,1,3.2.7c3.38,5.267,9.68,7.937,18.724,7.937,8.531,0,14.625-2.373,18.113-7.053,4.6-6.169,4.992-16.639,1.162-30.348H-3.753c-2.235,8-3.041,14.886-2.395,20.5a2.314,2.314,0,0,1-2.035,2.564,2.314,2.314,0,0,1-2.564-2.035c-.762-6.624.259-14.7,3.035-24.006a2.314,2.314,0,0,1,2.218-1.653h42.03a2.314,2.314,0,0,1,2.218,1.653c4.835,16.2,4.361,28.347-1.408,36.09C32.937-66.061,25.595-63.062,15.521-63.062Z",
    transform: "translate(10.991 109.72)",
    fill: "#2979ff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurity);
export default __webpack_public_path__ + "static/media/security.acd2c05a5135ace7e0e829d5e7a0bce9.svg";
export { ForwardRef as ReactComponent };